import React from 'react';

import '../style.scss';

export const Announcements = () => {
  return (
    <div className="announcements-skeleton" />
  );
};
